export default {
  nodes: [
    {
      match: [
        {
          object: 'text',
        },
      ],

      text: /regulate expression/,
    },
  ],
};
